export default __webpack_public_path__ + "static/media/node.ff3fc554.png";